<template>
  <div style="padding: 10px;">
    
    <div class="col-md-12">
      <h4>Cidadãos</h4>
    </div>
    <div class="col-md-12" v-if="sucessoDelete">
        <div class="card" style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;" >
            <div class="card-body">
                <div class="row">
                  <div class="col-md-4" >
                      {{sucessoDelete}}
                  </div>
                </div>
            </div>  
        </div> 
    </div>
    <div class="col-md-12" v-if="result_detalhes">
      <div class="card" style="margin-top:20px;">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">Nome: {{result_detalhes.nome}}</div>
            <div class="col-md-12">Email: {{result_detalhes.email}}</div>
          </div>
          <div class="row">
            <div class="col-md-12">Tipo: Pessoa {{result_detalhes.tipo}}</div>
            <div class="col-md-12" v-if="result_detalhes.cpf">CPF: {{result_detalhes.cpf}}</div>
            <div class="col-md-12" v-if="result_detalhes.cnpj">CNPJ: {{result_detalhes.cnpj}}</div>
            <div class="col-md-12" v-if="result_detalhes.status">Ativo</div>
            <div class="col-md-12" v-else>Desativado</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <vue-good-table
        :columns="columns"
        :rows="cidadaos_exibir"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15, 30],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props" >
          <div v-if="props.column.field == 'status'">
            <switch-button
              v-model="props.row.status"
              color="#253DB9"
              :meuid="props.row.uuid"
              modulo="cidadao"
              funcao="exibirStatus"
            ></switch-button>
          </div>

          <span v-if="props.column.field == 'action'">
            <button
              class="btn btn-success"
              @click="detalhes(props.row.uuid)"
              style="margin-right: 5px; 
                border-color: rgb(0, 150, 136); color: rgb(0, 150, 136);"
            >
              <i class="fa fa-eye"></i>
            </button>
            <button class="btn btn-primary"  @click="editar(props.row)" style="margin-right:5px;"   v-if="admin" >
              <i class="fa fa-pencil-square-o"></i> 
            </button>
            <!--<button class="btn btn-danger" @click="delete_option(props.row.uuid)" >
              <i class="fa fa-times"></i>
            </button>-->
          </span>
          <span v-else>
            <span v-if="props.column.field != 'status'">{{props.formattedRow[props.column.field]}}</span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/cidadaoController.js";
import "src/controller/sistema/usuarioController.js";
import SwitchButton from "src/components/switch.vue";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton,
  },
  data() {
    return {
      columns: [
        {
          label: "Usuario",
          field: "nome",
        },
        {
          label: "Tipo",
          field: "tipo",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Status",
          field: "status",
          hidden: true,
        },
        {
          label: "Ações",
          field: "action",
          sortable: false,
        },
        {
          label: "id",
          field: "uuid",
          hidden: true,
        },
      ],
      cidadaos: [],
      cidadaos_exibir: [],
      result_detalhes: null,
      sucessoDelete:null,
      user: {
        admin: null,
        admin_sistema: null,
        editor: null,
        tipo:0,
      },
      admin:false,
    };
  },
  methods: {
    editar(row) {
      this.$router.push({ name: "cidadao", params: { row: row } });
    },
    async delete_option(id) {
      try {
        let r = confirm("Deseja excluir o usuario?");
        if (r == true) {
          let m = await this.$me();
          let data = await this.$cidadaoDelete(id, m.id);
          this.sucessoDelete = "Deletado com Sucesso!";
          this.cidadaos_exibir = [];
          this.result_detalhes = null;
          this.listarTudo();
        }
      } catch (e) {
        console.log(e);
      }
    },
    detalhes(id) {
      let detalhe_cidadao = [];
      this.cidadaos_exibir.forEach((element) => {
        if (id == element.uuid) {
          detalhe_cidadao = element;
        }
      });

      this.result_detalhes = detalhe_cidadao;
    },
    async listarTudo() {
      try {
        let data = await this.$listarDadosdoCidadaos();
        this.cidadaos = data.data.reverse();

        let a = await this.$listarUsuariosCidadaos();
        let users = a.data;

        this.cidadaos.forEach((array) => {
          this.filtro(array, users);
        });

        //console.log(this.cidadaos_exibir);
      } catch (e) {}
    },
    async filtro(array, users) {
      try {
        let cidadao_nome;
        let cidadao_email;
        let cidadao_status;
        users.forEach((element) => {
          if (array.uuid == element.id_cidadao) {
            cidadao_nome = element.name;
            cidadao_email = element.email;
            cidadao_status = element.status;
          }
        });

        if (cidadao_status == 1) {
          cidadao_status = true;
        } else {
          cidadao_status = false;
        }

        let user = {
          uuid: array.uuid,
          tipo: array.tipo,
          cpf: array.cpf,
          cnpj: array.cnpj,
          nome: cidadao_nome,
          email: cidadao_email,
          status: cidadao_status,
        };
        this.cidadaos_exibir.push(user);
      } catch (error) {}
    },
  },
  async beforeMount() {
    try {
      
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
      this.user.tipo = store.tipo;
   
      if(store.tipo == 1){
        this.admin = true;
      }
      this.listarTudo();
    } catch (e) {}
  },
};
</script>

